import {ready} from '~/core'

ready('body_outline', 'body', body => {
	body.addEventListener('mousedown', function() {
		body.classList.add('is-usingMouse');
	});
	body.addEventListener('keydown', function() {
		body.classList.remove('is-usingMouse');
	});
});